import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

export const GreenCheckCircleIcon = styled(CheckCircleIcon)`
  color: lightgreen;
`;
